import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	justify-content: space-between;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		white-space: nowrap;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export { StyledButtonContent, StyledContainer, StyledLeftContainer };
